<template>
  <div class="card-container">
    <common-top-form
      selectShowPower="/spmgr/select"
      :model="formModel"
      @openAddDialog="addInfoAdd"
      :submitService="searchList"
      :submitData="searchDataList"
      @success="onSuccess"
      addShowPower="/spmgr/add"
    >
      <el-form-item label="代理商ID" prop="id">
        <el-input
          type="text"
          maxlength="20"
          v-model="searchData.userId"
          placeholder="请输入代理商ID"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="userId"
        label="代理商ID"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="chnCode"
        label="通道代码"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="probability"
        label="概率（千分比）"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      >
      </el-table-column>
      <el-table-column
        prop="threshold"
        label="阀值百分比（百分比）"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="addInfo(scope.row)">修改</el-button>
          <el-button type="text" @click="doStatus(scope.row)">{{
            scope.row.status == 1 ? "禁用" : "启用"
          }}</el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="`通道代码： ${dialogModel.chnCode}`"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="250px"
    >
      <el-form-item label="概率（千分比）" prop="probability">
        <el-input-number
          v-model="dialogModel.probability"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="阀值百分比（百分比）" prop="threshold">
        <el-input-number
          v-model="dialogModel.threshold"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
    <!-- 添加 -->
    <form-dialog
      ref="formDialogAdd"
      :formDialogTitle="'添加'"
      :model="formModel"
      :dialogService="submitService"
      :submitData="submitData"
      class="over"
      @success="formSuccess"
      @close="formClose"
      labelWidth="250px"
    >
      <el-form-item label="代理商ID" prop="id">
        <el-input
          type="text"
          show-word-limit
          v-model="formModel.userId"
          placeholder="请输入代理商ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="通道" prop="">
        <el-select v-model="formModel.chnCode">
          <el-option
            v-for="item in upTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="概率（千分比）" prop="probability">
        <el-input-number
          v-model="formModel.probability"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="阀值百分比（百分比）" prop="threshold">
        <el-input-number
          v-model="formModel.threshold"
          :min="0"
          :max="999999999"
          :step="0"
          :precision="0"
          :controls="false"
          placeholder="请输入"
        ></el-input-number>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import SystemPropertiesService from "service/SystemPropertiesService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "systempropertiesmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      upTypes: [],
      searchData: {
        userId: "",
      },
      formModel: {
        userId: "",
        probability: "",
        chnCode: "",
        threshold: "",
      },
      tableData: [],
      dialogModel: {
          probability:'',
        chnCode: "",
        threshold: "",
      },
      page: {},
      isPage: false,
      submitService: SystemPropertiesService.meltAddPeo,
      dialogService: SystemPropertiesService.meltEditPeo,
      searchList: SystemPropertiesService.meltListPeo,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    // this.getList();
    this.getTypeNames("chnName", (res) => {
      this.upTypes = [...[], ...res];
    });
    this.load();
  },
  computed: {
    searchDataList() {
      const params = {
        userId: this.searchData.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params
  }
      },
    dialogData() {
      const params = {
        probability: this.dialogModel.probability,
        chnCode: this.dialogModel.chnCode,
        threshold: this.dialogModel.threshold,
        id: this.dialogModel.id,
      };
      return params;
    },
    submitData() {
      const params = {
        userId: this.formModel.userId,
        probability: this.formModel.probability,
        chnCode: this.formModel.chnCode,
        threshold: this.formModel.threshold,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      return params;
    },

    ...mapGetters(["serverType", "tatId", "userId"]),

  
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    load() {
      this.formModel = {};
      this.page = this.$refs.commonTable.page;
      this.getList();
    },
    getList() {
      this.doLoad(
        SystemPropertiesService.meltListPeo,
       this.searchDataList,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.records;
              this.page.currentPage = result.current;
            this.page.total = result.total;
            this.page.pageSize = result.size;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    doStatus(item) {
      const _this = this;
      this.showConfirm("确认操作此通道？").then(() => {
        _this.doLoad(
          SystemPropertiesService.meltEditPeo,
         
          {
            id: item.id,
            status: item.status == 1 ? 0 : 1,
          },
          (res) => {
            this.doCheck(res, (res) => {
              this.showSuccess(res.respMsg);
              this.getList();
            });
          },
          "信息获取失败"
        );
      });
    },
    addInfo(item) {
      this.dialogModel = item;
      this.$nextTick(() => {
        this.$refs.formDialog.open();
      });
    },
    addInfoAdd() {
      this.$nextTick(() => {
        this.$refs.formDialogAdd.open();
      });
    },
    dialogSuccess(res) {
      this.showSuccess(res.respMsg);
      this.$refs.formDialog.closeDialog();
      this.formModel = {};
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {};
    },
    formSuccess(res) {
      this.showSuccess(res.respMsg);
      this.$refs.formDialogAdd.closeDialog();
      this.formModel = {};
      this.getList();
    },
    formClose() {
      this.formModel = {};
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.records;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/SystemManage/peopeizhi.vue